/**
 * Right-panel tab ids for the tests feature. Shared between the manifest
 * (which registers the panel views) and the center views (which open/focus them
 * via `useLayoutStore`). Keep in sync with `manifest.ts`.
 */

/** Description-block form (create and edit) — see `AdminTestDescriptionFormView`. */
export const TEST_DESCRIPTION_FORM_TAB = 'admin-test-description-form';

/** Read-only detail of the linked evaluation selected in the center view. */
export const TEST_EVALUATION_TAB = 'admin-test-evaluation-detail';
